import React, { useEffect } from 'react'
import DataGrid from 'react-data-grid'
import { Icon } from '@iconify/react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import Layout from '../../../../brands/components/Layout'
import './index.css'
import { getCalendar } from '../../api'
import {
    HIDE_LOADER,
    SHOW_LOADER,
} from '../../../../../redux/slices/LoaderSlice'
import { useAppDispatch, useAppSelector } from '../../../../../redux/hook'
import CustomPagination from '../../../../../components/Pagination'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import DelCalendarEvent from '../../components/DelCalendarEvent'
import { saveEventList } from '../../slice/eventSlice'

const SyncTable: React.FC = () => {
    const [currentPage, setCurrentPage] = React.useState<number>(1)
    const [tooltipState, setTooltipState] = React.useState<{
        [key: number]: boolean
    }>({})
    const [deleteForm, setDeleteForm] = React.useState(false)
    const [eventId, setEventId] = React.useState<string>('')

    const { eventList: rows, totalCount } = useAppSelector(
        (state: any) => state.googleEvents
    )

    const totalPages = Math.ceil(totalCount / 10)

    const { t } = useTranslation()
    const navigate = useNavigate()
    const dispatch = useAppDispatch()

    const handleCopy = async (id: number, text: string) => {
        try {
            await navigator.clipboard.writeText(text)
            setTooltipState((prevState) => ({
                ...prevState,
                [id]: true,
            }))
            setTimeout(() => {
                setTooltipState((prevState) => ({
                    ...prevState,
                    [id]: false,
                }))
            }, 2000)
        } catch (err) {
            console.error('Failed to copy: ', err)
        }
    }

    const column = [
        {
            key: 'title',
            name: `Title`,
            resizable: true,
            sortable: true,
            width: 200,
        },
        {
            key: 'url',
            name: `URL`,
            resizable: true,
            sortable: true,
            flexGrow: 1,
            width: 800,
        },
        {
            key: 'copy',
            name: '', // Fix the typo here
            resizable: true,
            sortable: true,
            width: 100,
            renderCell: (e: any) => (
                <>
                    <div className="dropdown-custom-link">
                        <span className="ms-2 ">
                            <OverlayTrigger
                                placement="top"
                                show={tooltipState[e.row.id] || false}
                                overlay={
                                    <Tooltip id="copy-tooltip">
                                        Copied !!
                                    </Tooltip>
                                }
                            >
                                <Icon
                                    icon="fa-solid:copy"
                                    className="pointer"
                                    color="#3d87de"
                                    onClick={() =>
                                        handleCopy(e.row.id, e.row.url)
                                    }
                                />
                            </OverlayTrigger>
                        </span>
                    </div>
                </>
            ),
        },
        {
            key: 'actions',
            name: `${t('brand.tableColumns.action')}`, // Fix the typo here
            resizable: true,
            sortable: true,
            width: 100,
            renderCell: (e: any) => (
                <>
                    <div className="dropdown-custom-link">
                        <Icon
                            onClick={() => {
                                navigate(`/sync/user?guid=${e.row.id}`)
                            }}
                            icon="bx:edit"
                            className="icon-primary pointer"
                        />
                        <Icon
                            onClick={() => {
                                setEventId(e.row.id)
                                setDeleteForm(true)
                            }}
                            icon="icon-park-outline:delete"
                            className="icon-secondary pointer"
                        />
                    </div>
                </>
            ),
        },
    ]

    const laodAllCalendars = async () => {
        dispatch(SHOW_LOADER())
        try {
            const response = await getCalendar({
                currentPage: currentPage,
                recordsPerPage: 10,
            })
            const data = response?.data?.data.map((item: any) => {
                return {
                    title: item.name,
                    url: item.url,
                    id: item.id,
                }
            })
            dispatch(
                saveEventList({
                    data: data,
                    totalCount: response?.data?.totalCount,
                    currentPage: currentPage,
                })
            )
            dispatch(HIDE_LOADER())
        } catch (error) {
            dispatch(HIDE_LOADER())
        }
    }

    useEffect(() => {
        laodAllCalendars()
    }, [currentPage])

    const getCurrentPage = (page: number) => {
        setCurrentPage(page)
    }
    return (
        <div>
            {deleteForm && (
                <DelCalendarEvent
                    data={{ id: eventId }}
                    onClose={setDeleteForm}
                    show={deleteForm}
                />
            )}
            <Layout>
                <div className="col-12 grid-custom-table">
                    <div className="page-information mb-3">
                        <div className="d-flex justify-content-between align-items-center">
                            <div>
                                <h4>Sync to Google Calendar</h4>
                            </div>
                            <div>
                                <div className="add-btns">
                                    <a
                                        onClick={() => {
                                            navigate('/sync/user')
                                        }}
                                        className="button button-primary"
                                    >
                                        ADD
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <DataGrid
                        className="sync-calendar-table data-grid-table"
                        columns={column}
                        rows={rows}
                        rowHeight={60}
                        headerRowHeight={40}
                    />
                    {rows?.length > 0 && (
                        <div className="mt-2">
                            <CustomPagination
                                totalPages={totalPages}
                                currentPage={currentPage}
                                getPageNumber={getCurrentPage}
                            />
                        </div>
                    )}
                </div>
            </Layout>
        </div>
    )
}

export default SyncTable
